import { render } from "./PauseIcon.vue?vue&type=template&id=9cb7b5aa"
import script from "./PauseIcon.vue?vue&type=script&lang=js"
export * from "./PauseIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__